import { useState, useEffect } from "react";

export default function Header() {
  const [ShowMenu, SetShowMenu] = useState(false);
  const ShowHideMenu = () => {
    SetShowMenu(!ShowMenu);
  };
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // const router = useRouter();

  return (
    <>
      <div
        // style={
        //   scrolled
        //     ? {
        //         backgroundImage: "url('/images/texture.jpg')",
        //         backgroundSize: "cover",
        //         backgroundPosition: "center",
        //         // transition: "all 0.3s ease",
        //       }
        //     : {
        //         backgroundImage: "unset",
        //         transition: "all 0.3s ease",
        //       }
        // }
        className={`header flex-d flex-ac flex-jsb ${scrolled ? "has-scroll" : ""}`}
      >
        <div className="flex-d flex-ac flex-gap40 b-bottom pl-20">
          <div className="menu flex-d flex-ac pointer" onClick={ShowHideMenu}>
            <img
              src="/images/menu-lines2.svg"
              width={19}
              height={14}
              alt="Menu"
            />
            <span>Menu</span>
          </div>
          <a className="menu flex-d flex-ac hide-md">Store</a>
        </div>
        <div className="logo flex-d">
          <img
            // src="/images/logo.svg"
            src="https://rodriguezcigarskeywest.com/wp-content/themes/rodriguez/images/logo_agecheck.svg"
            width={163}
            height={70}
            className="img-logo"
            alt="Menu"
          />
        </div>
        <div className="flex-d flex-ac flex-gap40 flex-jse b-bottom pr-20 gap-sm">
          <a className="menu flex-d flex-ac">
            <img src="/images/login2.svg" width={19} height={19} alt="Menu" />
            <span>Login</span>
          </a>
          <a className="menu flex-d flex-ac no-border">
            <img src="/images/cart2.svg" width={18} height={19} alt="Menu" />
            <span>Cart</span>
          </a>
        </div>
      </div>
      <div
        className={`menu-left ${ShowMenu === true ? "menu-show2" : ""}`}
        onClick={ShowHideMenu}
      >
        <div
          className={`menu-list ${ShowMenu === true ? "menu-show" : ""}`}
          style={{
            backgroundImage: "url('/images/texture.jpg')",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="flex-d flex-ad pl-20 pointer" onClick={ShowHideMenu}>
            <div className="menu flex-d flex-ac">
              <img src="/images/cross2.svg" width={14} height={14} alt="Menu" />
              Menu
            </div>
          </div>
          <div className="menu-items">
            <a className="hide-lg">Store</a>
            <a>History</a>
            <a>Cigar Collection</a>
            <a>Events</a>
            <a>Become a Retailer</a>
          </div>
        </div>
      </div>
    </>
  );
}
